<!-- DOM element to check if an uncaught error occurs and the DOM fails to load the application -->
<div id="dom-loaded" style="display: none;"></div>
<!-- Google Tag Manager (noscript) -->
<noscript>
  <iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-WTBB6FS"
    height="0"
    width="0"
    style="display:none;visibility:hidden"
    sandbox="allow-scripts"
    referrerpolicy="no-referrer"
    title="Google Tag Manager"
  >
  </iframe>
</noscript>
<!-- End Google Tag Manager (noscript) -->
<!-- splash screen -->
<div #splashScreen class="m-splash-screen">
  <img [attr.src]="splashScreenImage" style="width: 200px; margin-bottom: 30px;" />
  <!--here we will have circle progress bar-->
  <mat-spinner diameter="40"></mat-spinner>
</div>

<m-spinner-overlay></m-spinner-overlay>
<m-confirmation-overlay></m-confirmation-overlay>
<!-- !version 16 -> 17 -->
<!-- <notifier-container></notifier-container> -->

<router-outlet></router-outlet>
